<script setup lang="ts">
    import { onMounted, ref } from 'vue';
    import AiEditor from '@cwd/AiTools/AiEditor.vue';

    const show = ref<boolean>(false);

    const props = defineProps<{
        editor: {
            contentEditable: any;
            sync: () => void;
            show: KnockoutObservable<boolean>;
        };
    }>();

    onMounted(async () => {
        props.editor.show &&
            props.editor.show.subscribe((newValue: boolean) => {
                show.value = newValue;
            });
    });

    const getContent = () => {
        return props.editor.contentEditable[0].innerHTML;
    };

    const updateContent = (newValue: string) => {
        props.editor.contentEditable[0].innerHTML = newValue;
        props.editor.sync();
        props.editor.show(false);
    };

    const close = () => {
        props.editor.show(false);
    };
</script>

<template>
    <AiEditor :getContent="getContent" :show="show" @update:content="updateContent" @close="close"></AiEditor>
</template>
